import { useMsal } from "@azure/msal-react";
import Tab from "@mui/material/Tab";
import { styled } from "@mui/material/styles";
import axios from "axios";
import React, { useEffect, useState } from "react";
import Floaticons from "../Floaticons";
import "./PowerbiContent.css";
import PowerbiLearningCards from "./PowerbiLearningCards";
import PowerbiLearningJourney from "./PowerbiLearningJourney";
import "./SREContent.css";
import mailData from ".././../data/mailData";
function PowerbiContent() {
  const { instance } = useMsal();
  const [username, setuserName] = useState(null);
  const [isUserPresent, setuserPresent] = useState(true);
  const [value, setValue] = React.useState("1");
  const AntTab = styled((props) => <Tab disableRipple {...props} />)(
    ({ theme }) => ({
      textTransform: "none",
      minWidth: 0,
      [theme.breakpoints.up("sm")]: {
        minWidth: 0,
      },
      fontWeight: 500,
      fontSize: "16px",
      marginRight: theme.spacing(1),
      color: "white",
      background: "#344B5D",
      borderRadius: "50px",

      "&.Mui-selected": {
        color: "#141414",
        fontWeight: 600,
        fontSize: "16px",

        backgroundColor: "#F0F0F0",
      },
      "&.Mui-focusVisible": {
        backgroundColor: "#F0F0F0",
      },
    })
  );
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  //const baseURL = "http://localhost:3004";
  const baseURL = "https://atci.lkm.accenture.com/shell-university-apis";
  let program = "Power BI";
  const activeAccount = instance.getActiveAccount();
  //  const checkUserPresent = (name) => {
  //   axios
  //    .get(`${baseURL}/checkNominationList/${name}/${program}`, {
  //     headers: {
  //      "Cache-Control": "no-cache",
  //      Accept: "application/json",
  //      Pragma: "no-cache",
  //      Expires: "0",
  //     },
  //    })
  //    .then((res) => {
  //     console.log("Reponse is", res.data);
  //     let users = res.data;
  //     axios
  //      .get(`${baseURL}/checkAdminList/${name}`, {
  //       headers: {
  //        "Cache-Control": "no-cache",
  //        Accept: "application/json",
  //        Pragma: "no-cache",
  //        Expires: "0",
  //       },
  //      })
  //      .then((res) => {
  //       console.log("Reponse is", res.data);

  //       users.length != 0 || res.data.length != 0
  //        ? setuserPresent(true)
  //        : setuserPresent(false);
  //      })
  //      .catch((err) => {
  //       console.log(err);
  //      });
  //    })
  //    .catch((err) => {
  //     console.log(err);
  //    });
  //  };

  const checkUserPresent = (name) => {
    axios
      .get(`${baseURL}/checkUserActive/${name}`, {
        headers: {
          "Cache-Control": "no-cache",
          Accept: "application/json",
          Pragma: "no-cache",
          Expires: "0",
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        let activeUser = res.data;
        if (activeUser.length != 0) {
          axios
            .get(`${baseURL}/checkNominationList/${name}/${program}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              let users = res.data;
              users.length != 0 ? setuserPresent(true) : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          axios
            .get(`${baseURL}/checkAdminList/${name}`, {
              headers: {
                "Cache-Control": "no-cache",
                Accept: "application/json",
                Pragma: "no-cache",
                Expires: "0",
                Authorization: localStorage.getItem("token"),
                "Content-Type": "application/json",
              },
            })
            .then((res) => {
              console.log("Reponse is", res.data);

              res.data.length != 0
                ? setuserPresent(true)
                : setuserPresent(false);
            })
            .catch((err) => {
              console.log(err);
            });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(() => {
    if (activeAccount) {
      setuserName(activeAccount.idTokenClaims.enterpriseID);

      checkUserPresent(activeAccount.idTokenClaims.enterpriseID);
    } else {
      setuserName(null);
    }
  }, [activeAccount.idTokenClaims.enterpriseID]);
  return (
    <>
      <div id="PowerBi">
        <div className="main-banner">
          <img
            src="images/PowerBi/PowerBI-banner.png"
            alt="Banner"
            className="banner-img"
          />
          <img
            src="images/Home/banner-strip.png"
            alt="strip"
            className="strip-img"
          />
          <div className="announcemnt-box">
            <p>
              <img
                src="images/Home/speaker.png"
                alt="speaker"
                className="speaker-img"
              />
              <marquee
                width="92%"
                direction="left"
                style={{ display: "inline-block", verticalAlign: "middle" }}
              >
                {" "}
                <b>Come Join Us</b> on an exhilarating learning Journey on
                Enbridge Talent Academy Platform!!!
              </marquee>
            </p>
          </div>
          <Floaticons />
        </div>
        {isUserPresent ? (
          <div className="main-container">
            {/* section 1  */}
            <div className="about-container">
              <div className="about-wrap">
                <h2>About Power BI</h2>
                <p>
                  Power BI is a suite of features offered by Microsoft to help
                  regular people like you and me perform high-quality business
                  intelligence analysis, gain insights ourselves, and provide
                  access to those analyses and insights to the rest of our
                  organization.
                </p>
              </div>
            </div>
            {/* section 2  */}
            {/* <div id="SRE-Objective">
       <div className="program-container">
        <div className="program-wrap">
         <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "#B6C6F9" }}>
           <TabList
            sx={{ paddingLeft: "20px", paddingRight: "20px", paddingBottom: "10px" }}
            onChange={handleChange}
            aria-label="lab API tabs example"
           >
            <AntTab label="Program Objectives" value="1" />
            <AntTab label="Recordings & Guidelines" value="2" />
           </TabList>
          </Box>
          <TabPanel value="1" sx={{ marginTop: "40px" }}>
           {" "}
           <Stack direction={"row"}>
            <Box sx={{ width: "60%" }}>
             <ul>
              <li>
               Identify the primary components of the Power BI interface: reports, data,
               and model views.
              </li>
              <li>Import Excel data and build basic visuals</li>
              <li>Publish a desktop report to the Power BI Service</li>
             </ul>
            </Box>
           </Stack>
          </TabPanel>
          <TabPanel sx={{ marginTop: "40px" }} value="2">
           <Box sx={{ justifyContent: "center", display: "flex", alignItems: "center" }}>
            <Stack
             direction={"row"}
             spacing={2}
             sx={{
              height: "300px",
              display: "flex",
              width: "80%",
              justifyContent: "center",
             }}
            >
          

             <Stack
              sx={{ justifyContent: "center", alignItems: "center", cursor: "pointer" }}
              spacing={3}
             >
              <iframe
               id="kmsembed-1_79d4hrr2"
               width="450"
               height="300"
               src="https://mediaexchange.accenture.com/embed/secure/iframe/entryId/1_79d4hrr2/uiConfId/27188232/st/0"
               class="kmsembed"
               allowfullscreen
               webkitallowfullscreen
               mozAllowFullScreen
               allow="autoplay *; fullscreen *; encrypted-media *"
               referrerPolicy="no-referrer-when-downgrade"
               frameborder="0"
               title="Power BI SME connect  _ Shell University-20230615_120753-Meeting Recording (1)"
              ></iframe>

              <Stack direction={"row"} spacing={0}>
               <Typography>SME Connect</Typography>
               <img
                style={{ width: "30px", height: "28px " }}
                src="images/tosca/arrow.png"
               ></img>
              </Stack>
             </Stack>
            </Stack>
           </Box>
          </TabPanel>
         </TabContext>
      
        </div>
       </div>
      </div> */}

            <div id="SRE-Objective">
              <div className="program-container">
                <div className="program-wrap">
                  <h2>Program Objectives</h2>
                  <ul id="double">
                    <li>
                      Identify the primary components of the Power BI interface:
                      reports, data, and model views.
                    </li>
                    <li>Import Excel data and build basic visuals</li>
                    <li>Publish a desktop report to the Power BI Service</li>
                  </ul>
                </div>
              </div>
            </div>
            <PowerbiLearningJourney />
            <div className="external-certification-container">
              <h5>External Certifications</h5>
              <p>
                Complete your learning journey and earn accredited external
                certification in the area of your expertise which can help in
                advancing your career.
              </p>
              <div className="ex-wrapper">
                <div className="ex-box">
                  <img
                    src="images/PowerBi/certifications/1.png"
                    alt="certification-icon"
                  />
                  <span>Exam PL-300: Microsoft Power BI Data Analyst</span>
                </div>
                <div className="ex-box">
                  <img
                    src="images/PowerBi/certifications/2.png"
                    alt="certification-icon"
                  />
                  <span>
                    Microsoft Certified: Power BI Data Analyst Associate
                  </span>
                </div>
                <div className="ex-box third">
                  <img
                    src="images/PowerBi/certifications/3.png"
                    alt="certification-icon"
                  />
                  <span>
                    DP-500: Designing and Implementing Enterprise-Scale
                    Analytics Solutions Using Microsoft Azure and Microsoft
                    Power BI
                  </span>
                </div>
                <div className="ex-box">
                  <img
                    src="images/PowerBi/certifications/4.png"
                    alt="certification-icon"
                  />
                  <span>
                    Microsoft Certified: Azure Enterprise Data Analyst Associate
                  </span>
                </div>
              </div>
            </div>
            <PowerbiLearningCards />
            <div className="features-container SRE">
              <h5>Program Highlights</h5>
              <div className="features-wrap">
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon1.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Self-paced Learning</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon2.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>SME Connects</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon3.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Final Assessment</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon4.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>Earn Completion Certificates, Flair, R&R</p>
                </div>
                <div className="features-row">
                  <img
                    src="images/SRE/feature-icon6.png"
                    alt="feature-icon"
                    className="feature-icon"
                  />
                  <p>End-to-End case studies</p>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="alter-conatiner">
            <p>
              You are not enrolled to this learning program. Please contact
              &nbsp;
              <a
                onClick={() => {
                  window.open(`mailto:${mailData.enbridge_talentAcademy_mail}`);
                }}
                href=""
              >
                {mailData.enbridge_talentAcademy_mail}
              </a>
              &nbsp; for any queries regarding the program.
            </p>
          </div>
        )}
      </div>
    </>
  );
}

export default PowerbiContent;
